import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MediaGalleryItem } from 'src/app/components/shared-components/media-gallery/media-gallery-item/media-gallery-item.model';

@Component({
  selector: 'app-media-gallery-add-html-dialog',
  templateUrl: './media-gallery-add-html-dialog.component.html',
  styleUrls: ['./media-gallery-add-html-dialog.component.scss']
})
export class MediaGalleryAddHtmlDialogComponent implements OnInit {

  htmlCode: string;
  isURLRegExp = new RegExp('^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$');
  constructor(public dialogRef: MatDialogRef<MediaGalleryAddHtmlDialogComponent>) {
  }

  ngOnInit() { }

  public accept() {
    if (this.validateForm()) {
      if (this.isURLRegExp.test(this.htmlCode)) {
        this.dialogRef.close(new MediaGalleryItem(null, 'Html', 'WEB_URL', this.htmlCode, null, false, null, 60, null, null));
      } else {
        this.dialogRef.close(new MediaGalleryItem(null, 'Html', 'WEB_SCRIPT', this.htmlCode, null, false, null, 60, null, null));
      }
    } else {
      return false;
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public validateForm() {
    if (!this.htmlCode) {
      return false;
    } else {
      return true;
    }
  }
}
